import React from 'react';
import PropTypes from 'prop-types';
import {NavigationList} from './NavigationList';
import './style.scss';

/**
 * NavigationBar: A navigation component
 *  - Display various points of the slide in display.
 *  - Clicking a point will scroll to that point.
 */
function NavigationBar(props) {
  return (
    <div className='navigation'>
      <div className='navigation__menuList'>{props.children}</div>
      <div className='navigation__progressBase' />
    </div>
  );
}

NavigationBar.propTypes = {
  /**
   * Element to be displayed as child for Navigation Bar
   */
  children: PropTypes.element.isRequired,
};

export {NavigationBar, NavigationList};
